// slideshow-link.js — makes whole slide clickable using button href
document.addEventListener('DOMContentLoaded', function(){
  try {
    document.querySelectorAll('.slideshow__slide').forEach(function(slide){
      // find a real link inside text wrapper (button)
      var btn = slide.querySelector('.slideshow__text-wrapper a[href]');
      if(!btn) return;
      var href = btn.getAttribute('href');
      if(!href) return;

      // if we've already created overlay anchor, update and skip
      var exist = slide.querySelector('.slide-overlay-link');
      if(exist){ exist.href = href; return; }

      // make slide a positioning context
      slide.style.position = slide.style.position || 'relative';

      // create overlay anchor that covers whole slide
      var a = document.createElement('a');
      a.className = 'slide-overlay-link';
      a.href = href;
      a.setAttribute('aria-label', btn.textContent || 'Open slide');
      // style to cover area (inline so no extra CSS required)
      Object.assign(a.style, {
        position: 'absolute',
        inset: '0',
        zIndex: 9998,        // below popups but above image
        display: 'block',
        textDecoration: 'none',
        background: 'transparent'
      });

      // put overlay at top of slide (prepend so it is before text wrapper)
      slide.prepend(a);

      // ensure the button itself remains clickable (it sits above overlay visually)
      // set button z-index higher
      btn.style.zIndex = 9999;
      btn.style.position = btn.style.position || 'relative';
    });
  } catch(e){ console && console.error(e); }
});
